import React, { useEffect, useRef, useState } from "react";

const Compare = () => {
  const compareScrollRef = useRef<HTMLDivElement>(null);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    const compareScroll = compareScrollRef.current;
    if (!compareScroll) return undefined;

    const handleScroll = () => {
      setHasScrolled(compareScroll.scrollLeft > 8);
    };

    compareScroll.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => {
      compareScroll.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="compare-section" aria-labelledby="compare-title">
      <div className="container">
        <div className="head">
          <h2 className="section-title" id="compare-title">
            42courses vs typical online courses.
          </h2>
          <p className="section-sub">
            We won't name them by name, but you know the ones we mean.
          </p>
        </div>
        <div className={`compare-table${hasScrolled ? " scrolled" : ""}`}>
          <div className="compare-swipe-hint" aria-hidden="true">
            <span className="hint-arrow">→</span>
            <span className="hint-text">Swipe to compare</span>
          </div>
          <div
            className="compare-scroll"
            id="compareScroll"
            ref={compareScrollRef}
          >
            <table>
              <thead>
                <tr>
                  <th scope="col">Feature</th>
                  <th scope="col">42courses</th>
                  <th scope="col">Typical platform</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Marking &amp; feedback by real people</td>
                  <td>
                    <span className="check">✓</span>Within 24 hours
                  </td>
                  <td>
                    <span className="cross">×</span>Auto-quiz only
                  </td>
                </tr>
                <tr>
                  <td>Personalised by role &amp; sector</td>
                  <td>
                    <span className="check">✓</span>AI rewrites every lesson
                  </td>
                  <td>
                    <span className="cross">×</span>Same content for everyone
                  </td>
                </tr>
                <tr>
                  <td>Taught by working practitioners</td>
                  <td>
                    <span className="check">✓</span>The people who wrote the
                    book
                  </td>
                  <td>
                    <span className="cross">×</span>Often academics or actors
                  </td>
                </tr>
                <tr>
                  <td>Average completion rate</td>
                  <td>
                    <span className="check">✓</span>Over 80%
                  </td>
                  <td>
                    <span className="cross">×</span>5 to 15% (industry average)
                  </td>
                </tr>
                <tr>
                  <td>CPD-accredited Mini MBA certificate</td>
                  <td>
                    <span className="check">✓</span>Every course
                  </td>
                  <td>
                    <span className="cross">×</span>Sometimes
                  </td>
                </tr>
                <tr>
                  <td>30-day money back, no questions</td>
                  <td>
                    <span className="check">✓</span>If you aren't happy, we
                    aren't
                  </td>
                  <td>
                    <span className="cross">×</span>Usually a 7-day refund
                    window
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Compare;
